// extracted by mini-css-extract-plugin
export default {"productGrid":"H2-z","centerLink":"I2-z","productSection":"J2-z","item":"K2-z","ctaButton":"L2-z"};